import React, { useState, useEffect, useRef } from "react";
import { X } from "lucide-react";
import AiText from "@/components/AiText";

// Fixed bottom-right teacher character; the AI's latest reply appears in a speech bubble beside her.
export default function TeacherAvatar({ message, typing, idle }) {
  const [open, setOpen] = useState(true);
  const bubbleRef = useRef(null);
  const showText = Boolean(message && message.trim());

  useEffect(() => {
    if (bubbleRef.current) bubbleRef.current.scrollTop = bubbleRef.current.scrollHeight;
  }, [message, typing]);

  if (!open) {
    return (
      <button
        data-testid="teacher-avatar-open"
        onClick={() => setOpen(true)}
        className="fixed bottom-4 right-4 z-40 rounded-full shadow-xl ring-4 ring-white bg-gradient-to-b from-rose-50 to-white"
        aria-label="Nokta Öğretmen'i göster"
      >
        <img src="/teacher-avatar.png" alt="Nokta Öğretmen" className="w-14 h-14 object-cover object-top rounded-full" draggable="false" />
      </button>
    );
  }

  return (
    <div
      data-testid="teacher-avatar"
      className="fixed bottom-0 right-0 z-40 pointer-events-none flex items-end justify-end p-2 sm:p-3"
    >
      <div className="flex items-end gap-1.5 sm:gap-2">
        <div className="pointer-events-auto relative mb-8 sm:mb-10 animate-float-up">
          <div
            ref={bubbleRef}
            data-testid="teacher-bubble"
            className="relative bg-white border border-slate-200 shadow-2xl rounded-2xl rounded-br-md px-4 py-3 w-[62vw] sm:w-80 max-h-[42vh] overflow-y-auto"
          >
            <p className="text-[11px] font-extrabold text-indigo-600 mb-1">👩‍🏫 Nokta Öğretmen</p>
            {typing && !showText ? (
              <span className="inline-flex gap-1 py-1.5" data-testid="teacher-typing">
                <span className="w-2 h-2 bg-indigo-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
                <span className="w-2 h-2 bg-indigo-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
                <span className="w-2 h-2 bg-indigo-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
              </span>
            ) : (
              <div className="text-sm text-slate-700">
                <AiText text={showText ? message : idle} />
                {typing && <span className="inline-block w-1.5 h-4 bg-indigo-500 animate-pulse ml-0.5 align-middle" />}
              </div>
            )}
            <span className="absolute -right-1.5 bottom-5 w-3 h-3 bg-white border-r border-b border-slate-200 rotate-45" />
          </div>
        </div>

        <div className="relative pointer-events-none shrink-0">
          <button
            data-testid="teacher-avatar-close"
            onClick={() => setOpen(false)}
            className="pointer-events-auto absolute top-0 left-0 z-10 bg-white/90 hover:bg-white text-slate-500 rounded-full p-1 shadow-md"
            aria-label="Gizle"
          >
            <X className="w-3.5 h-3.5" />
          </button>
          <img
            src="/teacher-avatar.png"
            alt="Nokta Öğretmen"
            draggable="false"
            className="w-24 sm:w-32 lg:w-40 drop-shadow-2xl select-none"
          />
        </div>
      </div>
    </div>
  );
}
